import { Directive, Input, TemplateRef } from "@angular/core";

@Directive({
  selector: '[dg-expand-content]'
})
export class DataGridExpandChildContent {
  @Input() colSpan: string = "0";
  constructor(public templateRef: TemplateRef<any>) { }
}
